// import React, { useState, useEffect } from 'react';
// import { useDispatch } from 'react-redux';
// import * as actions from '../../../../Redux/Actions';
// import { Award, NominationWindow } from './award.types';
// import ModalComponents from '../../../../component/ModalComponent/ModalComponent';
// import { Dropdown, Form } from 'react-bootstrap';
// import Button from '../../../../component/Buttons/Button';
// import { showErrorToastMessage, showSuccessToastMessage } from '../../../../component/Toasts/Toasts';

// interface AwardModalProps {
//     show: boolean;
//     onHide: () => void;
//     onSuccess: () => void;
//     awardToEdit?: Award | null;
// }

// const AwardModal = ({ show, onHide, onSuccess, awardToEdit }: AwardModalProps) => {
//     const dispatch = useDispatch();
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const isEditMode = !!awardToEdit;
//     const [errors, setErrors] = 
//     useState<Partial<Record<keyof typeof initialFormState | 'nominationStart' | 'nominationEnd', string>>>({});

//     // const initialFormState = {
//     //     awardCategory: '',
//     //     frequency: 'Quarterly',
//     //     definition: '',
//     //     remarks: '',
//     //     tenure: 0,
//     //     employmentType: ['Full time', 'Part-time', 'Contract'],
//     //     specialConditions: '',
//     //     result: [] as string[],
//     //     approvalWorkflow: 'Single level',
//     //     notificationRules: {
//     //         notifyOnSubmit: true,
//     //         notifyOnApprove: true,
//     //         notifyOnReject: true,
//     //         publishWinners: false,
//     //     },
//     //     fiscalYearStartMonth: 4, 
//     //     nominationWindowDates: {
//     //         start: '',
//     //         end: ''
//     //     },
//     //     maxWinnersPerCycle: 0,
//     //     nominationLimitPerRM: 0,
//     // };

//     const initialFormState = {
//         awardCategory: '',
//         definition: '',
//         remarks: '',
//         eligibility: {
//             tenure: 0,
//             employmentType: ['Full time', 'Part-time', 'Contract'],
//             specialConditions: '',
//         },
//         result: [] as string[],
//         approvalWorkflow: 'Single level' as 'Single level' | 'Multi-level',
//         notificationRules: {
//             notifyOnSubmit: true,
//             notifyOnApprove: true,
//             notifyOnReject: true,
//             publishWinners: false,
//         },
//         nominationWindow: {
//             frequency: 'Monthly' as NominationWindow['frequency'],
//             startRule: 'First X Days' as NominationWindow['startRule'],
//             durationInDays: 10,
//             startDate: '',
//             endDate: '',
//         },
//         maxWinnersPerCycle: 1,
//         nominationLimitPerRM: 1,
//     };

//     const [awardData, setAwardData] = useState(initialFormState);

//     const formatDateForInput = (date: Date | string | undefined) => {
//         if (!date) return '';
//         try {
//             return new Date(date).toISOString().split('T')[0];
//         } catch {
//             return '';
//         }
//     };

//     useEffect(() => {
//         if (show) {
//             if (isEditMode && awardToEdit) {
//                 setAwardData({
//                     awardCategory: awardToEdit.awardCategory || '',
//                     definition: awardToEdit.definition || '',
//                     remarks: awardToEdit.remarks || '',
//                     eligibility: {
//                         tenure: awardToEdit.eligibility?.tenure || 0,
//                         employmentType: awardToEdit.eligibility?.employmentType || [],
//                         specialConditions: awardToEdit.eligibility?.specialConditions || '',
//                     },
//                     result: awardToEdit.result || [],
//                     approvalWorkflow: awardToEdit.approvalWorkflow || 'Single level',
//                     notificationRules: awardToEdit.notificationRules || initialFormState.notificationRules,
//                     nominationWindow: {
//                         frequency: awardToEdit.nominationWindow?.frequency || 'Monthly',
//                         startRule: awardToEdit.nominationWindow?.startRule || 'First X Days',
//                         durationInDays: awardToEdit.nominationWindow?.durationInDays || 10,
//                         startDate: formatDateForInput(awardToEdit.nominationWindow?.startDate),
//                         endDate: formatDateForInput(awardToEdit.nominationWindow?.endDate),
//                     },
//                     maxWinnersPerCycle: awardToEdit.maxWinnersPerCycle || 1,
//                     nominationLimitPerRM: awardToEdit.nominationLimitPerRM || 1,
//                 });
//             } else {
//                 setAwardData(initialFormState);
//             }
//         }
//     }, [awardToEdit, show]); 

//     const validateForm = (): boolean => {
//         const newErrors: typeof errors = {};

//         // Text fields
//         if (!awardData.awardCategory.trim()) newErrors.awardCategory = 'Award Name is required.';
//         if (!awardData.definition.trim()) newErrors.definition = 'Award Definition is required.';
//         //if (!awardData.specialConditions.trim()) newErrors.specialConditions = 'Special Conditions are required.';
//         //if (!awardData.remarks.trim()) newErrors.remarks = 'Remarks are required.';
        
//         // Number fields
//         if (!awardData.maxWinnersPerCycle || awardData.maxWinnersPerCycle <= 0) newErrors.maxWinnersPerCycle = 'Max Winners must be at least 1.';
//         if (!awardData.nominationLimitPerRM || awardData.nominationLimitPerRM <= 0) newErrors.nominationLimitPerRM = 'Nomination Limit must be at least 1.';
//         if (awardData.eligibility.tenure === null || awardData.eligibility.tenure < 0) newErrors.eligibility = 'Minimum Tenure cannot be negative.';

//         // Date fields
//         if (!awardData.nominationWindow.startDate) newErrors.nominationStart = 'Nomination Start Date is required.';
//         if (!awardData.nominationWindow.endDate) newErrors.nominationEnd = 'Nomination End Date is required.';
//         if (awardData.nominationWindow.startDate && awardData.nominationWindow.endDate) {
//             if (new Date(awardData.nominationWindow.endDate) < new Date(awardData.nominationWindow.startDate)) {
//                 newErrors.nominationEnd = 'End Date cannot be before Start Date.';
//             }
//         }

//         // Array fields
//         if (awardData.result.length === 0) newErrors.result = 'At least one Result/Prize must be selected.';

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };


//     const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
//         const { name, value } = e.target;
//         setAwardData(prev => ({ ...prev, [name]: value }));
//     };

//     // const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     //     const { name, value } = e.target;
//     //     setAwardData(prev => ({
//     //         ...prev,
//     //         nominationWindowDates: {
//     //             ...prev.nominationWindow?.startDate,
//     //             [name]: value
//     //         }
//     //     }));
//     // };

//     const handleNominationWindowChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
//         const { name, value } = e.target;
//         setAwardData(prev => ({
//             ...prev,
//             nominationWindow: {
//                 ...prev.nominationWindow,
//                 [name]: value
//             }
//         }));
//     };
    
//     const handleFrequencySelect = (key: any) => {
//         setAwardData(prev => ({
//             ...prev,
//             nominationWindow: {
//                 ...prev.nominationWindow,
//                 frequency: key
//             }
//         }));
//     };

//     const handleDropdownSelect = (name: string, value: any) => {
//         setAwardData(prev => ({ ...prev, [name]: value }));
//     };

//     const handleMultiSelectChange = (field: 'result' | 'employmentType', value: string) => {
//         setAwardData(prev => {
//             const currentValues = prev[field] || [];
//             const newValues = currentValues.includes(value)
//                 ? currentValues.filter(v => v !== value)
//                 : [...currentValues, value];            
//             return { ...prev, [field]: newValues };
//         });
//     };

//     const handleSubmit = () => {
//         if (!validateForm()) {
//             showErrorToastMessage('Please fill out all required fields correctly.');
//             return;
//         }
//         setIsSubmitting(true);

//         // const payload: Partial<Award> = {
//         //     awardCategory: awardData?.awardCategory,
//         //     frequency: awardData?.frequency,
//         //     definition: awardData?.definition,
//         //     result: awardData?.result,
//         //     approvalWorkflow: awardData?.approvalWorkflow,
//         //     eligibility: {
//         //         tenure: awardData?.tenure > 0 ? awardData?.tenure : undefined,
//         //         employmentType: ['Full time', 'Part-time', 'Contract'],
//         //         specialConditions: awardData?.specialConditions || undefined,
//         //     },
//         //     notificationRules: awardData?.notificationRules,
//         //     remarks: awardData?.remarks || undefined,
//         // };
//         // if (payload.frequency === 'Quarterly') {
//         //     payload.fiscalYearStartMonth = Number(awardData.fiscalYearStartMonth);
//         // }
//         // if (awardData.nominationWindowDates.start && awardData.nominationWindowDates.end) {
//         //     payload.nominationWindowDates = {
//         //         start: new Date(awardData.nominationWindowDates.start),
//         //         end: new Date(awardData.nominationWindowDates.end),
//         //     };
//         // }

//          const nominationWindowPayload: Partial<NominationWindow> = {
//             frequency: awardData.nominationWindow.frequency,
//         };

//         switch (awardData.nominationWindow.frequency) {
//             case 'Monthly':
//                 nominationWindowPayload.startRule = awardData.nominationWindow.startRule;
//                 nominationWindowPayload.durationInDays = Number(awardData.nominationWindow.durationInDays);
//                 break;
//             case 'Custom Range':
//                 nominationWindowPayload.startDate = awardData.nominationWindow.startDate;
//                 nominationWindowPayload.endDate = awardData.nominationWindow.endDate;
//                 break;
//         }

//         const payload = {
//             awardCategory: awardData.awardCategory,
//             definition: awardData.definition,
//             eligibility: {
//                 tenure: Number(awardData.eligibility.tenure) || undefined,
//                 employmentType: awardData.eligibility.employmentType,
//                 specialConditions: awardData.eligibility.specialConditions || undefined,
//             },
//             remarks: awardData.remarks || undefined,
//             result: awardData.result,
//             nominationWindow: nominationWindowPayload, // Use the cleaned payload
//             maxWinnersPerCycle: Number(awardData.maxWinnersPerCycle),
//             nominationLimitPerRM: Number(awardData.nominationLimitPerRM),
//             approvalWorkflow: awardData.approvalWorkflow,
//             notificationRules: awardData.notificationRules,
//         };

//        if (isEditMode && awardToEdit) {
//             // --- DISPATCH UPDATE ACTION ---
//             dispatch(actions.updateAwardAction(awardToEdit._id, payload, (res: any) => {
//                 setIsSubmitting(false);
//                 if (res.success) {
//                     showSuccessToastMessage('Award updated successfully!');
//                     onSuccess();
//                     onHide();
//                 } else {
//                     showErrorToastMessage(res.error?.error_description || 'Failed to update award.');
//                 }
//             }));
//         } else {
//             // --- DISPATCH CREATE ACTION ---
//             dispatch(actions.createAwardAction(payload, (res: any) => {
//                 setIsSubmitting(false);
//                 if (res.success) {
//                     showSuccessToastMessage('Award created successfully!');
//                     onSuccess();
//                     onHide();
//                 } else {
//                     showErrorToastMessage(res.error?.error_description || 'Failed to create award.');
//                 }
//             }));
//         }
//     };

//     const fiscalYearOptions = [
//         { name: "Calendar Year (Jan - Mar)", value: 1 },
//         { name: "Fiscal Year (Apr - Jun)", value: 4 },
//         { name: "Fiscal Year (Jul - Sept)", value: 7 },
//         { name: "Fiscal Year (Oct - Dec)", value: 10 }
//     ];

//     const modalBodyContent = (
//         <div className="container-fluid">
//             {/* Modal Header*/}
//             <div className='row'>
//                 <div className="col-md-12 mt-3 mb-3">
//                     <h5 style={{ fontWeight: 'bold', textAlign: 'center', textDecoration: 'underline' }}>
//                         {isEditMode ? 'Edit Award' : 'Add New Award'}
//                     </h5>
//                 </div>
//             </div>

//             <div className="row g-3">
//                 {/* Award Name */}
//                 <div className="col-md-6">
//                     <label className="form-label">Award Name<span className="required">*</span></label>
//                     <input 
//                         type="text" 
//                         className="form-control" 
//                         name="awardCategory" 
//                         required
//                         aria-required
//                         value={awardData.awardCategory} 
//                         onChange={handleInputChange} 
//                         placeholder='E.g., Star Performer of the Quarter'
//                     />
//                     {errors.awardCategory && <div className="invalid-feedback">{errors.awardCategory}</div>}
//                 </div>

//                 {/* Frequency Dropdown */}
//                 <div className="col-md-6">
//                     <label className="form-label">Frequency of Distribution<span className="required">*</span></label>
//                     <Dropdown onSelect={handleFrequencySelect}>
//                         <Dropdown.Toggle variant="light" className="form-control text-start d-flex justify-content-between align-items-center">
//                             {awardData.nominationWindow.frequency}
//                         </Dropdown.Toggle>
//                         <Dropdown.Menu>
//                             <Dropdown.Item eventKey="Monthly">Monthly</Dropdown.Item>
//                             <Dropdown.Item eventKey="Quarterly">Quarterly</Dropdown.Item>
//                             <Dropdown.Item eventKey="Yearly">Yearly</Dropdown.Item>
//                             <Dropdown.Item eventKey="Ad-hoc">Ad-hoc</Dropdown.Item>
//                             <Dropdown.Item eventKey="Custom Range">Custom Range</Dropdown.Item>
//                         </Dropdown.Menu>
//                     </Dropdown>
//                 </div>

//                 {awardData.nominationWindow.frequency === 'Monthly' && (
//                     <>
//                         <div className="col-md-6">
//                             <label className="form-label">Start Rule</label>
//                             <select 
//                                 className="form-select" 
//                                 name="startRule" 
//                                 value={awardData.nominationWindow.startRule} 
//                                 onChange={handleNominationWindowChange}
//                             >
//                                 <option value="First X Days">First X Days</option>
//                                 <option value="Last X Days">Last X Days</option>
//                             </select>
//                         </div>
//                         <div className="col-md-6">
//                             <label className="form-label">Duration in Days</label>
//                             <input
//                                 type="number"
//                                 min="1"
//                                 className="form-control"
//                                 name="durationInDays"
//                                 value={awardData.nominationWindow.durationInDays}
//                                 onChange={handleNominationWindowChange}
//                             />
//                         </div>
//                     </>
//                 )}

//                 {/* --- CONDITIONAL UI for 'Custom Range' --- */}
//                 {awardData.nominationWindow.frequency === 'Custom Range' && (
//                     <>
//                         <div className="col-md-6">
//                             <label className="form-label">Start Date</label>
//                             <input
//                                 type="date"
//                                 className="form-control"
//                                 name="startDate"
//                                 value={awardData.nominationWindow.startDate}
//                                 onChange={handleNominationWindowChange}
//                             />
//                         </div>
//                         <div className="col-md-6">
//                             <label className="form-label">End Date</label>
//                             <input
//                                 type="date"
//                                 className="form-control"
//                                 name="endDate"
//                                 value={awardData.nominationWindow.endDate}
//                                 onChange={handleNominationWindowChange}
//                             />
//                         </div>
//                     </>
//                 )}
                
//                 {/* Max Winners & Nomination Limit */}
//                 <div className="row g-3">
//                     <div className="col-md-6">
//                         <label className="form-label">Maximum Number of Winners per Cycle<span className="required">*</span></label>
//                         <input
//                             type="number"
//                             min="1"
//                             className={`form-control ${errors.maxWinnersPerCycle ? 'is-invalid' : ''}`}
//                             name="maxWinnersPerCycle"
//                             value={awardData.maxWinnersPerCycle}
//                             onChange={handleInputChange}
//                         />
//                         {errors.maxWinnersPerCycle && <div className="invalid-feedback">{errors.maxWinnersPerCycle}</div>}
//                     </div>
//                     <div className="col-md-6">
//                         <label className="form-label">Nomination Limit per Reporting Manager<span className="required">*</span></label>
//                         <input
//                             type="number"
//                             min="1"
//                             className={`form-control ${errors.nominationLimitPerRM ? 'is-invalid' : ''}`}
//                             name="nominationLimitPerRM"
//                             value={awardData.nominationLimitPerRM}
//                             onChange={handleInputChange}
//                         />
//                         {errors.nominationLimitPerRM && <div className="invalid-feedback">{errors.nominationLimitPerRM}</div>}
//                     </div>
//                 </div>

//                 {/* Nomination Window Dates (side by side) */}
//                 {/* <div className="row g-3 mt-2">
//                     <div className="col-md-6">
//                         <label className="form-label">Nomination Start Date<span className="required">*</span></label>
//                         <input
//                             type="date"
//                             className={`form-control ${errors.nominationStart ? 'is-invalid' : ''}`}
//                             name="start"
//                             value={awardData.nominationWindow.startDate}
//                             onChange={handleDateChange}
//                         />
//                         {errors.nominationStart && <div className="invalid-feedback">{errors.nominationStart}</div>}
//                     </div>
//                     <div className="col-md-6">
//                         <label className="form-label">Nomination End Date<span className="required">*</span></label>
//                         <input
//                             type="date"
//                             className={`form-control ${errors.nominationEnd ? 'is-invalid' : ''}`}
//                             name="end"
//                             value={awardData.nominationWindowDates.end}
//                             onChange={handleDateChange}
//                         />
//                         {errors.nominationEnd && <div className="invalid-feedback">{errors.nominationEnd}</div>}
//                     </div>
//                 </div> */}

//                 {/* Description  aka Definition */}
//                 <div className="col-12">
//                     <label className="form-label">Award Definition<span className="required">*</span></label>
//                     <textarea
//                         className={`form-control ${errors.definition ? 'is-invalid' : ''}`}
//                         name="definition" 
//                         rows={10}
//                         cols={50}
//                         required
//                         value={awardData.definition} 
//                         onChange={handleInputChange}
//                         placeholder="Explain what this award is for..."
//                     ></textarea>
//                     {errors.definition && <div className="invalid-feedback">{errors.definition}</div>}
//                 </div>

//                 <div className="col-12"><hr className="my-2"/></div>

//                 {/* Eligibility */}
//                 <div className="col-md-6">
//                     <label className="form-label">Minimum Tenure (Months)<span className="required">*</span></label>
//                     <input 
//                         type="number" 
//                         min="0" 
//                         className={`form-control ${errors.eligibility.tenure ? 'is-invalid' : ''}`} 
//                         name="tenure" 
//                         value={awardData.eligibility.tenure} 
//                         onChange={handleInputChange} 
//                     />
//                     {errors.tenure && <div className="invalid-feedback">{errors.eligibility.tenure}</div>}
//                 </div>
                
//                 {/* //Employment Type - removed. Default value set to all types
//                 <div className="col-md-6">
//                     <label className="form-label">Employment Type</label>
//                     <div className="p-2 border rounded d-flex flex-wrap gap-3">
//                         {['Full-time', 'Part-time', 'Contract'].map(type => (
//                             <Form.Check 
//                                 key={type}
//                                 type="checkbox"
//                                 id={`emp-type-${type}`}
//                                 label={type}
//                                 checked={awardData.employmentType.includes(type)}
//                                 onChange={() => handleMultiSelectChange('employmentType', type)}
//                             />
//                         ))}
//                     </div>
//                 </div> */}

//                 {/* Approval Workflow */}
//                 <div className="col-md-6">
//                     <label 
//                     className="form-label"
//                     >
//                         Approval Workflow
//                         <span className="required">*</span>
//                     </label>
//                     <Dropdown onSelect={(key) => handleDropdownSelect('approvalWorkflow', key)}>
//                         <Dropdown.Toggle
//                         variant="light"
//                         className="form-control"
//                         >
//                         {awardData.approvalWorkflow}
//                         </Dropdown.Toggle>
//                         <Dropdown.Menu>
//                         <Dropdown.Item eventKey="Single level">Single level</Dropdown.Item>
//                         <Dropdown.Item eventKey="Multi-level">Multi-level</Dropdown.Item>
//                         </Dropdown.Menu>
//                     </Dropdown>
//                 </div>

//                 {/* Special Conditions */}
//                 <div className="col-12"> 
//                     <label className="form-label">Special Conditions</label>
//                     <textarea
//                         className="form-control"
//                         name="specialConditions"
//                         rows={10}
//                         value={awardData.specialConditions}
//                         onChange={handleInputChange}
//                         placeholder="e.g., Nomination is for one team per client..."
//                     ></textarea>
//                 </div>
                
//                 <div className="col-12"><hr className="my-2"/></div>

//                 {/* Results & Workflow */}
//                 <div className="col-md-12">
//                     <label className="form-label">Result / Prize<span className="required">*</span></label>
//                     <div className={`p-2 border rounded d-flex flex-wrap gap-3 ${errors.result ? 'is-invalid' : ''}`}>
//                         {['Trophy', 'Certificate', 'Monetary Reward', 'Appreciation Email', 'Badge'].map(prize => (
//                             <Form.Check 
//                                 key={prize}
//                                 type="checkbox"
//                                 id={`prize-${prize}`}
//                                 label={prize}
//                                 checked={awardData.result.includes(prize)}
//                                 onChange={() => handleMultiSelectChange('result', prize)}
//                             />
//                         ))}
//                     </div>
//                     {errors.result && <div className="invalid-feedback d-block">{errors.result}</div>}
//                 </div>

//                 {/* Remarks */}
//                 <div className="col-12">
//                     <label className="form-label">Remarks</label>
//                     <textarea
//                         className="form-control"
//                         name="remarks"
//                         rows={10}
//                         value={awardData.remarks}
//                         onChange={handleInputChange}
//                         placeholder="Optional internal remarks (e.g., Awarded during Townhall)"
//                     ></textarea>
//                 </div>

//                 {/* Notification Rules */}
//                 <div className="col-12 mt-3">
//                     <label className="form-label">Notification Rules</label>
//                     <div className="d-flex flex-wrap gap-3">
//                         {Object.keys(awardData.notificationRules).map((rule) => (
//                         <div className="form-check" key={rule}>
//                             <input
//                             type="checkbox"
//                             className="form-check-input"
//                             id={rule}
//                             checked={awardData.notificationRules[rule as keyof typeof awardData.notificationRules]}
//                             onChange={(e) =>
//                                 setAwardData(prev => ({
//                                 ...prev,
//                                 notificationRules: {
//                                     ...prev.notificationRules,
//                                     [rule]: e.target.checked,
//                                 }
//                                 }))
//                             }
//                             />
//                             <label className="form-check-label" htmlFor={rule}>
//                             {rule}
//                             </label>
//                         </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>

//             {/* CTA Buttons */}
//             <div className="d-flex justify-content-end mt-4">
//                 <button 
//                     type="button" 
//                     className="btn cancel-btn me-2" 
//                     onClick={onHide} 
//                     disabled={isSubmitting}
//                 >
//                     Cancel
//                 </button>
//                 <Button 
//                     title={isSubmitting ? "Saving..." : "Save Award"} 
//                     onClick={handleSubmit} 
//                     disabled={isSubmitting} 
//                     className="add-submit-button" 
//                 />
//             </div>
//         </div>
//     );

//     return (
//         <ModalComponents
//             show={show}
//             onHide={onHide}
//             title={"Award Details"}
//             modalBody={modalBodyContent}
//             className="modal-lg" 
//         />
//     );
// };

// export default AwardModal;

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '../../../../Redux/Actions';
import { Award, NominationWindow } from './rnr.types';
import ModalComponents from '../../../../component/ModalComponent/ModalComponent';
import { Dropdown, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Button from '../../../../component/Buttons/Button';
import { showErrorToastMessage, showSuccessToastMessage } from '../../../../component/Toasts/Toasts';
import { RiInformationLine } from 'react-icons/ri';

interface AwardModalProps {
  show: boolean;
  onHide: () => void;
  onSuccess: () => void;
  awardToEdit?: Award | null;
}

const AwardModal = ({ show, onHide, onSuccess, awardToEdit }: AwardModalProps) => {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isEditMode = !!awardToEdit;

  const MAX_AWARD_NAME_LENGTH = 150;
  const MAX_DEFINITION_LENGTH = 2000;
  const MAX_CONDITIONS_LENGTH = 1000;
  const MAX_REMARKS_LENGTH = 1000;

  const initialFormState = {
    awardCategory: '',
    definition: '',
    remarks: '',
    eligibility: {
      tenure: 0,
      employmentType: ['Full time', 'Part-time', 'Contract'],
      specialConditions: '',
    },
    result: [] as string[],
    approvalWorkflow: 'Single level' as 'Single level' | 'Multi-level',
    notificationRules: {
      notifyOnSubmit: true,
      notifyOnApprove: true,
      notifyOnReject: true,
      publishWinners: false,
    },
    nominationWindow: {
      frequency: 'Monthly' as NominationWindow['frequency'],
      startRule: '' as NominationWindow['startRule'],
      durationInDays: undefined as NominationWindow['durationInDays'],
      startDate: '',
      endDate: '',
    },
    maxWinnersPerCycle: 1,
    nominationLimitPerRM: 1,
  };

  const [awardData, setAwardData] = useState(initialFormState);
  const [errors, setErrors] = useState<
    Partial<Record<keyof typeof initialFormState | 'nominationStart' | 'nominationEnd' | 'durationInDays' | 'startRule', string>>
  >({});

  const formatDateForInput = (date: Date | string | undefined) => {
    if (!date) return '';
    try {
      return new Date(date).toISOString().split('T')[0];
    } catch {
      return '';
    }
  };

  useEffect(() => {
    if (show) {
      setErrors({});

      if (isEditMode && awardToEdit) {
        setAwardData({
          awardCategory: awardToEdit.awardCategory || '',
          definition: awardToEdit.definition || '',
          remarks: awardToEdit.remarks || '',
          eligibility: {
            tenure: awardToEdit.eligibility?.tenure || 0,
            employmentType: awardToEdit.eligibility?.employmentType || [],
            specialConditions: awardToEdit.eligibility?.specialConditions || '',
          },
          result: awardToEdit.result || [],
          approvalWorkflow: awardToEdit.approvalWorkflow || 'Single level',
          notificationRules: awardToEdit.notificationRules || initialFormState.notificationRules,
          nominationWindow: {
            frequency: awardToEdit.nominationWindow?.frequency || 'Monthly',
            startRule: awardToEdit.nominationWindow?.startRule || 'First X Days',
            durationInDays: awardToEdit.nominationWindow?.durationInDays ?? 10,
            startDate: formatDateForInput(awardToEdit.nominationWindow?.startDate),
            endDate: formatDateForInput(awardToEdit.nominationWindow?.endDate),
          },
          maxWinnersPerCycle: awardToEdit.maxWinnersPerCycle || 1,
          nominationLimitPerRM: awardToEdit.nominationLimitPerRM || 1,
        });
      } else {
        setAwardData(initialFormState);
      }
    }
  }, [awardToEdit, show]);

  const validateForm = (): boolean => {
    const newErrors: typeof errors = {};

    if (!awardData.awardCategory.trim()) newErrors.awardCategory = 'Award Name is required.';
    if (!awardData.definition.trim()) newErrors.definition = 'Award Definition is required.';

    if (!awardData.maxWinnersPerCycle || awardData.maxWinnersPerCycle <= 0) {
      newErrors.maxWinnersPerCycle = 'Max Winners must be at least 1.';
    }
    if (!awardData.nominationLimitPerRM || awardData.nominationLimitPerRM <= 0) {
      newErrors.nominationLimitPerRM = 'Nomination Limit must be at least 1.';
    }
    if (awardData.eligibility.tenure === null || awardData.eligibility.tenure < 0) {
      newErrors.eligibility = 'Minimum Tenure cannot be negative.';
    }

    switch (awardData.nominationWindow.frequency) {
      case 'Monthly':
      case 'Quarterly':
      case 'Yearly':
      {
        let maxDuration: number;
        let durationErrorMsg: string;

        if (awardData.nominationWindow.frequency === 'Monthly') {
          maxDuration = 31;
          durationErrorMsg = 'Duration cannot exceed 31 days for a monthly award.';
        } 
        else if (awardData.nominationWindow.frequency === 'Quarterly') {
          maxDuration = 92; // The longest possible quarter is 31+31+30 = 92 days
          durationErrorMsg = 'Duration cannot exceed 92 days for a quarterly award.';
        } 
        else {
          maxDuration = 366; // Use 366 to safely account for leap years
          durationErrorMsg = 'Duration cannot exceed 366 days for a yearly award.';
        }

        const duration = Number(awardData.nominationWindow.durationInDays);
        if (!duration || duration <= 0) {
          newErrors.durationInDays = 'Duration must be at least 1 day.';
        } else if (duration > maxDuration) {
          newErrors.durationInDays = durationErrorMsg;
        }

        if (!awardData.nominationWindow.startRule) {
          newErrors.startRule = 'Start Rule is required.';
        }
        break;
      }

      case 'Custom Range':
        if (!awardData.nominationWindow.startDate) newErrors.nominationStart = 'Nomination Start Date is required.';
        if (!awardData.nominationWindow.endDate) newErrors.nominationEnd = 'Nomination End Date is required.';
        if (awardData.nominationWindow.startDate && awardData.nominationWindow.endDate) {
          if (new Date(awardData.nominationWindow.endDate) < new Date(awardData.nominationWindow.startDate)) {
            newErrors.nominationEnd = 'End Date cannot be before Start Date.';
          }
        }
        break;
    }

    if (awardData.result.length === 0) newErrors.result = 'At least one Result/Prize must be selected.';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setAwardData(prev => ({ ...prev, [name]: value }));
  };

  const handleNominationWindowChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setAwardData(prev => ({
      ...prev,
      nominationWindow: {
        ...prev.nominationWindow,
        [name]: value
      }
    }));
  };

  const handleFrequencySelect = (key: any) => {
    setAwardData(prev => ({
      ...prev,
      nominationWindow: {
        ...prev.nominationWindow,
        frequency: key
      }
    }));
  };

  const handleDropdownSelect = (name: string, value: any) => {
    setAwardData(prev => ({ ...prev, [name]: value }));
  };

  const handleMultiSelectChange = (field: 'result', value: string) => {
    setAwardData(prev => {
      const currentValues = prev[field] || [];
      const newValues = currentValues.includes(value)
        ? currentValues.filter(v => v !== value)
        : [...currentValues, value];
      return { ...prev, [field]: newValues };
    });
  };

  const handleSubmit = () => {
    if (!validateForm()) {
      showErrorToastMessage('Please fill out all required fields correctly.');
      return;
    }
    setIsSubmitting(true);

    const nominationWindowPayload: Partial<NominationWindow> = {
      frequency: awardData.nominationWindow.frequency,
    };

    switch (awardData.nominationWindow.frequency) {
      case 'Monthly':
      case 'Quarterly':
      case 'Yearly':
        nominationWindowPayload.startRule = awardData.nominationWindow.startRule;
        nominationWindowPayload.durationInDays = Number(awardData.nominationWindow.durationInDays);
        break;
      case 'Custom Range':
        nominationWindowPayload.startDate = awardData.nominationWindow.startDate;
        nominationWindowPayload.endDate = awardData.nominationWindow.endDate;
        break;
    }

    const payload = {
      awardCategory: awardData.awardCategory,
      definition: awardData.definition,
      eligibility: {
        tenure: Number(awardData.eligibility.tenure) || undefined,
        employmentType: awardData.eligibility.employmentType,
        specialConditions: awardData.eligibility.specialConditions || undefined,
      },
      remarks: awardData.remarks || undefined,
      result: awardData.result,
      nominationWindow: nominationWindowPayload,
      maxWinnersPerCycle: Number(awardData.maxWinnersPerCycle),
      nominationLimitPerRM: Number(awardData.nominationLimitPerRM),
      approvalWorkflow: awardData.approvalWorkflow,
      notificationRules: awardData.notificationRules,
    };

    if (isEditMode && awardToEdit) {
      dispatch(actions.updateAwardAction(awardToEdit._id, payload, (res: any) => {
        setIsSubmitting(false);
        if (res.success) {
          showSuccessToastMessage('Award updated successfully!');
          onSuccess();
          onHide();
        } else {
          showErrorToastMessage(res.error?.error_description || 'Failed to update award.');
        }
      }));
    } else {
      dispatch(actions.createAwardAction(payload, (res: any) => {
        setIsSubmitting(false);
        if (res.success) {
          showSuccessToastMessage('Award created successfully!');
          onSuccess();
          onHide();
        } else {
          showErrorToastMessage(res.error?.error_description || 'Failed to create award.');
        }
      }));
    }
  };

  const handleClose = () => {
    setErrors({});
    setAwardData(initialFormState);
    setIsSubmitting(false);
    onHide();
  };

  const modalBodyContent = (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12 mt-3 mb-3">
          <h5 style={{ fontWeight: 'bold', textAlign: 'center', textDecoration: 'underline' }}>
            {isEditMode ? 'Edit Award' : 'Add New Award'}
          </h5>
        </div>
      </div>

      <div className="row g-3">
        
        {/* Award Name */}
        <div className="col-md-6">
          <label className="form-label">Award Name<span className="required">*</span></label>
          <input 
            type="text" 
            className={`form-control ${errors.awardCategory ? 'is-invalid' : ''}`} 
            name="awardCategory" 
            required
            maxLength={MAX_AWARD_NAME_LENGTH}
            value={awardData.awardCategory} 
            onChange={handleInputChange} 
            placeholder='E.g., Star Performer of the Quarter'
          />
          {errors.awardCategory && <div className="invalid-feedback d-block">{errors.awardCategory}</div>} 
        </div>

        {/* Frequency */}
        <div className="col-md-6">
          <label className="form-label">Frequency of Distribution<span className="required">*</span></label>
          <Dropdown onSelect={handleFrequencySelect}>
            <Dropdown.Toggle variant="light" className="form-control text-start d-flex justify-content-between align-items-center">
              {awardData.nominationWindow.frequency}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item eventKey="Monthly">Monthly</Dropdown.Item>
              <Dropdown.Item eventKey="Quarterly">Quarterly</Dropdown.Item>
              <Dropdown.Item eventKey="Yearly">Yearly</Dropdown.Item>
              <Dropdown.Item eventKey="Ad-hoc">Ad-hoc</Dropdown.Item>
              <Dropdown.Item eventKey="Custom Range">Custom Range</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* Nomination Window Dynamic Inputs */}
        {['Monthly', 'Quarterly', 'Yearly'].includes(awardData.nominationWindow.frequency) && (
          <>
            <div className="col-md-6">
              <label className="form-label">Nomination Timeline Window</label>
              <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip id="timeline-tooltip">
                      This defines when the nomination window opens relative to the period.
                      <br />
                      <strong>First 'X' Days:</strong> Opens at the start of the month/quarter/year.
                      <br />
                      <strong>Last 'X' Days:</strong> Opens towards the end of the month/quarter/year.
                    </Tooltip>
                  }
                >
                  {/* The span makes the hover area a bit larger and easier to click */}
                  <span className="ms-2" style={{ cursor: 'pointer' }}>
                    <RiInformationLine size={20} radius={10} />
                  </span>
                </OverlayTrigger>
              <select 
                className={`form-select ${errors.startRule ? 'is-invalid' : ''}`} 
                name="startRule" 
                value={awardData.nominationWindow.startRule} 
                onChange={handleNominationWindowChange}
              >
                <option value="" disabled>
                  Select a timeline rule...
                </option>
                <option value="First X Days">First 'X' Days of the Window </option>
                <option value="Last X Days">Last 'X' Days of the Window</option>
              </select>
              {errors.startRule && <div className="invalid-feedback">{errors.startRule}</div>}
            </div>
            <div className="col-md-6">
              <label className="form-label">Nomination timeline duration(in days)<span className="required">*</span></label>
              <input
                type="number"
                min="1"
                className={`form-control ${errors.durationInDays ? 'is-invalid' : ''}`}
                name="durationInDays"
                value={awardData.nominationWindow.durationInDays}
                onChange={handleNominationWindowChange}
              />
              {errors.durationInDays && <div className="invalid-feedback">{errors.durationInDays}</div>}
            </div>
          </>
        )}

        {awardData.nominationWindow.frequency === 'Custom Range' && (
          <>
            <div className="col-md-6">
              <label className="form-label">Start Date<span className="required">*</span></label>
              <input
                type="date"
                className={`form-control ${errors.nominationStart ? 'is-invalid' : ''}`}
                name="startDate"
                value={awardData.nominationWindow.startDate}
                onChange={handleNominationWindowChange}
              />
              {errors.nominationStart && <div className="invalid-feedback">{errors.nominationStart}</div>}
            </div>
            <div className="col-md-6">
              <label className="form-label">End Date<span className="required">*</span></label>
              <input
                type="date"
                className={`form-control ${errors.nominationEnd ? 'is-invalid' : ''}`}
                name="endDate"
                value={awardData.nominationWindow.endDate}
                onChange={handleNominationWindowChange}
              />
              {errors.nominationEnd && <div className="invalid-feedback">{errors.nominationEnd}</div>}
            </div>
          </>
        )}

        {awardData.nominationWindow.frequency === 'Ad-hoc' && (
          <div className="col-12">
            <div className="alert alert-info">This award will always remain open for nominations (Ad-hoc).</div>
          </div>
        )}

        {/* Definition */}
        <div className="col-12">
          <label className="form-label">Award Definition<span className="required">*</span></label>
          <textarea
            className={`form-control ${errors.definition ? 'is-invalid' : ''}`}
            name="definition" 
            rows={10}
            required
            value={awardData.definition} 
            onChange={handleInputChange}
            placeholder="Explain what this award is for..."
            maxLength={MAX_DEFINITION_LENGTH}
          ></textarea>
          {errors.definition && <div className="invalid-feedback">{errors.definition}</div>}
        </div>

        {/* Max Winners & Nomination Limit */}
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">Maximum Number of Winners per Cycle<span className="required">*</span></label>
            <input
              type="number"
              min="1"
              className={`form-control ${errors.maxWinnersPerCycle ? 'is-invalid' : ''}`}
              name="maxWinnersPerCycle"
              value={awardData.maxWinnersPerCycle}
              onChange={handleInputChange}
            />
            {errors.maxWinnersPerCycle && <div className="invalid-feedback">{errors.maxWinnersPerCycle}</div>}
          </div>
          <div className="col-md-6">
            <label className="form-label">Nomination Limit per Reporting Manager<span className="required">*</span></label>
            <input
              type="number"
              min="1"
              className={`form-control ${errors.nominationLimitPerRM ? 'is-invalid' : ''}`}
              name="nominationLimitPerRM"
              value={awardData.nominationLimitPerRM}
              onChange={handleInputChange}
            />
            {errors.nominationLimitPerRM && <div className="invalid-feedback">{errors.nominationLimitPerRM}</div>}
          </div>
        </div>

        {/* <div className="col-12"><hr className="my-2"/></div> */}

        {/* Eligibility */}
        <div className="col-md-6">
          <label className="form-label">Minimum Tenure (Months)<span className="required">*</span></label>
          <input 
            type="number" 
            min="0" 
            className={`form-control ${errors.eligibility ? 'is-invalid' : ''}`} 
            name="tenure" 
            value={awardData.eligibility.tenure} 
            onChange={(e) =>
              setAwardData(prev => ({
                ...prev,
                eligibility: { ...prev.eligibility, tenure: Number(e.target.value) }
              }))
            }
          />
          {errors.eligibility && <div className="invalid-feedback">{errors.eligibility}</div>}
        </div>

        {/* Approval Workflow */}
        <div className="col-md-6">
          <label className="form-label">Approval Workflow<span className="required">*</span></label>
          <Dropdown onSelect={(key) => handleDropdownSelect('approvalWorkflow', key)}>
            <Dropdown.Toggle variant="light" className="form-control">
              {awardData.approvalWorkflow}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item eventKey="Single level">Single level</Dropdown.Item>
              <Dropdown.Item eventKey="Multi-level">Multi-level</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* Special Conditions */}
        <div className="col-12"> 
          <label className="form-label">Special Conditions</label>
          <textarea
            className="form-control"
            name="specialConditions"
            rows={5}
            value={awardData.eligibility.specialConditions}
            onChange={(e) =>
              setAwardData(prev => ({
                ...prev,
                eligibility: { ...prev.eligibility, specialConditions: e.target.value }
              }))
            }
            placeholder="e.g., Nomination is for one team per client..."
            maxLength={MAX_CONDITIONS_LENGTH}
          ></textarea>
        </div>

        {/* <div className="col-12"><hr className="my-2"/></div> */}

        {/* Results */}
        <div className="col-md-12">
          <label className="form-label">Result / Prize<span className="required">*</span></label>
          <div className={`p-2 border rounded d-flex flex-wrap gap-3 ${errors.result ? 'is-invalid' : ''}`}>
            {['Trophy', 'Certificate', 'Monetary Reward', 'Appreciation Email', 'Badge'].map(option => (
              <Form.Check
                key={option}
                type="checkbox"
                id={`result-${option}`}
                label={option}
                checked={awardData.result.includes(option)}
                onChange={() => handleMultiSelectChange('result', option)}
              />
            ))}
          </div>
          {errors.result && <div className="invalid-feedback d-block">{errors.result}</div>}
        </div>

        {/* Remarks */}
        <div className="col-md-12">
          <label className="form-label">Remarks</label>
          <textarea
            className="form-control"
            name="remarks"
            rows={3}
            value={awardData.remarks}
            onChange={handleInputChange}
            maxLength={MAX_REMARKS_LENGTH}
          ></textarea>
        </div>

        {/* CTA Buttons */}
             <div className="d-flex justify-content-end mt-4">
                 <button 
                    type="button" 
                    className="btn cancel-btn me-2" 
                    onClick={handleClose} 
                    disabled={isSubmitting}
                >
                    Cancel
                </button>
                <Button 
                    title={isSubmitting ? "Saving..." : "Save Award"} 
                    onClick={handleSubmit} 
                    disabled={isSubmitting} 
                    className="add-submit-button" 
                />
            </div>
      </div>
    </div>
  );

  return (
    <ModalComponents
        show={show}
        onHide={handleClose}
        title={"Award Details"}
        modalBody={modalBodyContent}
        className="modal-lg" 
    />
  );
};

export default AwardModal;
